module.exports = __webpack_public_path__ + "img/payicon_toss.9a4d2474.png";